import { ILandingSection } from "../../../data/interfaces"
import DelimiterAnimationContent from "./DelimiterAnimationContent"
import DelimiterContent from "./DelimiterContent"
import DelimiterTransformContent from "./DelimiterTransformContent"

/* Protopia Ecosystem component */
export interface IDelimiterProps {
   section: ILandingSection
}
const Delimiter = (props: IDelimiterProps): JSX.Element => { 
    
    return <DelimiterTransformContent  section={props.section} >
        <DelimiterAnimationContent section={props.section} > 
            <DelimiterContent section={props.section} />
        </DelimiterAnimationContent>
    </DelimiterTransformContent>
}
export default Delimiter